module.exports = __webpack_public_path__ + "707a6ed6a7336f5823339c6768e51b7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/acadian_funds.png
// module id = 1605
// module chunks = 0